import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import { useDispatch, useSelector } from 'react-redux';
// Images
import Object2 from '../../assets/images/Object2.png';
import bitmap from '../../assets/images/Bitmap.png';

import imgDashboard from '../../assets/images/svg/dashboard.svg';
import imgNode from '../../assets/images/svg/my nodes.svg';
import imgInvestment from '../../assets/images/svg/investment.svg';
import imgFarm from '../../assets/images/svg/farm.svg';
import imgFaq from '../../assets/images/faq.png';
import imgDiscord from '../../assets/images/LeftBar/discord.png';
import imgTwitter from '../../assets/images/LeftBar/twitter.png';
import imgStack from '../../assets/images/LeftBar/stack.png';
import imgBubble from '../../assets/images/LeftBar/bubble.png';
import imgDiscordHover from '../../assets/images/svg/discord-hover.svg';
import imgTwitterHover from '../../assets/images/svg/twitter-hover.svg';
import imgMediumHover from '../../assets/images/svg/medium-hover.svg';
import imgGitbookHover from '../../assets/images/svg/gitbook-hover.svg';

import styles from './style.module.css';
import { useTheme } from '../../hooks';
import { updateSideBarState, updateActiveLinkState } from '../../redux/actions/uiActions';
import DashboardGold from '../../assets/images/imgsComp/DashboardGold';
import MyNodes from '../../assets/images/imgsComp/MyNodes';
import InvestmentGold from '../../assets/images/imgsComp/InvestmentGold';
import FarmGold from '../../assets/images/imgsComp/FarmGold';
import FaqGold from '../../assets/images/imgsComp/FaqGold';

const LeftSideBar = ({}) => {
  const dispatch = useDispatch();
  const { theme } = useTheme();
  const { toggleSidebar, activeLink } = useSelector((state) => state.ui);
  const { pathname } = useLocation();
  const useStyles = makeStyles((theme) => ({
    activeNav: {
      background: theme.palette.background.tabsBg,
      borderColor: theme.palette.border.lightColor,
      border: theme.palette.borderType.border1,
    },
    ActiveNavText: {
      color: theme.palette.text.light,
    },
    hoverNav: {
      '&:hover': {
        color: theme.palette.text.light,
        // background: theme.palette.background.hoverBg,
      },
    },
  }));

  const [toggleImg, setToggleImg] = useState();
  const [hoverImg, setHoverImg] = useState(null);
  const classes = useStyles();

  useEffect(() => {
    if (activeLink.initial) {
      switch (pathname) {
        case '/nodes':
          dispatch(updateActiveLinkState(1, false, true));
          break;
        case '/investment':
          dispatch(updateActiveLinkState(2, false, true));
          break;
        case '/farm':
          dispatch(updateActiveLinkState(3, false, true));
          break;
        case '/faq':
          dispatch(updateActiveLinkState(4, false, true));
          break;
        default:
          dispatch(updateActiveLinkState(0, false, true));
          break;
      }

      setTimeout(() => {
        dispatch(updateActiveLinkState(0, true, false));
      }, 100);
    }
  }, [[pathname, activeLink]]);

  useEffect(() => {
    const el = document.getElementById('active-nav');
    if (el) {
      el.style.top = 128 + activeLink.prev * 56 + 'px';
      setTimeout(() => {
        if (activeLink.start) {
          el.style.top = 128 + activeLink.next * 56 + 'px';
        }
      }, 1);
    }
  }, [activeLink]);

  // useEffect(() => {

  // }, []);

  const navClickHandler = (idx) => {
    setTimeout(() => {
      dispatch(updateActiveLinkState(0, true));
    }, 1000);
    dispatch(updateActiveLinkState(idx, false));
  };

  const setToggleSidebar = (bool) => {
    dispatch(updateSideBarState(bool));
  };
  return (
    <Box
      sx={{
        height: '100vh',
      }}
      display={{ xs: 'none', sm: 'none', md: 'flex' }}
    >
      {/* <Box
        sx={{
          width: '88px',
          height: '100%',
        }}
        style={{
          background: 'linear-gradient(180deg, #0E111C 0%, #11141D 100%',
        }}
      >
        <Box marginTop={20}>
          <Box marginBottom={4}>
            <Button
              variant="text"
              sx={{
                paddingX: '0',
                display: 'flex',
                justifyContent: 'flex-start',
              }}
              fullWidth
            >
              <Box>
                <Box
                  sx={{
                    width: '10px',
                    height: '50px',
                  }}
                  style={{
                    background:
                      'linear-gradient(131.78deg, #EEEEEE 12.72%, #D4C78C 21.39%, #DEBF70 34.64%, #AE9555 44.61%, #A78C47 57.04%)',
                  }}
                ></Box>
              </Box>
              <Box marginLeft={2}>
                <img src={imgHammer} alt="hammer" width={'32px'} height="32px" />
              </Box>
            </Button>
          </Box>

          <Box marginBottom={4}>
            <Button variant="text" sx={{ marginLeft: 2 }}>
              <img src={imgThunder} alt="thunder" width={'32px'} height="32px" />
            </Button>
          </Box>

          <Box marginBottom={4}>
            <Button variant="text" sx={{ marginLeft: 2 }}>
              <img src={Object} alt="thunder" width={'32px'} height="32px" />
            </Button>
          </Box>
        </Box>
      </Box> */}
      <Box sx={{ width: 69, height: '100%' }}>
        <Box
          onMouseOver={() => setToggleSidebar(true)}
          onMouseOut={() => setToggleSidebar(false)}
          display={{ xs: 'none', sm: 'none', md: 'flex' }}
          flexDirection="column"
          className={`${styles.sidebarContainer} ${toggleSidebar ? styles.show_sidebar : styles.off_sidebar}`}
        >
          <Box marginTop={16} paddingX={'15px'}>
            <Box id="active-nav" className={`${classes.activeNav} ${styles.moveNav}`}></Box>
            <Box marginBottom={2} onClick={(e) => navClickHandler(0)}>
              <NavLink
                onClick={() => {
                  setToggleSidebar(true);
                  setHoverImg(null);
                }}
                onMouseOver={() => setHoverImg(0)}
                onMouseOut={() => setHoverImg(null)}
                to="/"
                className={({ isActive }) =>
                  isActive
                    ? `${styles.activeRouteCollapse} ${classes.hoverNav} `
                    : `${styles.inActiveRouteCollapse} ${classes.hoverNav}`
                }
              >
                <Box className={styles.btnIcon}>
                  {
                    theme === 'dark' ? (
                      <img loading="lazy" src={imgDashboard} width={'16px'} />
                    ) : activeLink.next === 0 ? (
                      // <img loading="lazy" src={imgDashboardGold} width={'16px'} />
                      <DashboardGold />
                    ) : hoverImg === 0 ? (
                      <DashboardGold />
                    ) : (
                      <img loading="lazy" src={imgDashboard} width={'16px'} />
                    )
                    // <img loading="lazy" src={hoverImg === 0 ? imgDashboardGold : imgDashboard} width={'16px'} />
                  }
                </Box>
                <Box className={styles.btnText}>
                  <Typography
                    variant="subtitle2"
                    className={`${styles.text} ${activeLink.next === 0 ? classes.ActiveNavText : ''}`}
                    component="div"
                  >
                    DASHBOARD
                  </Typography>
                </Box>
              </NavLink>
            </Box>

            <Box marginBottom={2} onClick={(e) => navClickHandler(1)}>
              <NavLink
                onClick={() => {
                  setHoverImg(null);
                }}
                to="/nodes"
                onMouseOver={() => setHoverImg(1)}
                onMouseOut={() => setHoverImg(null)}
                className={({ isActive }) =>
                  isActive
                    ? `${styles.activeRouteCollapse} ${classes.hoverNav}`
                    : `${styles.inActiveRouteCollapse} ${classes.hoverNav}`
                }
              >
                <Box className={styles.btnIcon}>
                  {theme === 'dark' ? (
                    <img loading="lazy" src={imgNode} width={'16px'} alt="..." />
                  ) : activeLink.next === 1 ? (
                    <MyNodes />
                  ) : hoverImg === 1 ? (
                    <MyNodes />
                  ) : (
                    <img loading="lazy" src={imgNode} width={'16px'} alt="..." />
                  )}
                </Box>
                <Box className={styles.btnText}>
                  <Typography
                    variant="subtitle2"
                    className={`${styles.text} ${activeLink.next === 1 ? classes.ActiveNavText : ''}`}
                    component="div"
                  >
                    MY NODES
                  </Typography>
                </Box>
              </NavLink>
            </Box>

            <Box marginBottom={2} onClick={(e) => navClickHandler(2)}>
              <NavLink
                onClick={() => {
                  setHoverImg(null);
                }}
                to="/investment"
                onMouseOver={() => setHoverImg(2)}
                onMouseOut={() => setHoverImg(null)}
                className={({ isActive }) =>
                  isActive
                    ? `${styles.activeRouteCollapse} ${classes.hoverNav} `
                    : `${styles.inActiveRouteCollapse} ${classes.hoverNav}`
                }
              >
                <Box className={styles.btnIcon}>
                  {theme === 'dark' ? (
                    <img loading="lazy" src={imgInvestment} width={'16px'} />
                  ) : activeLink.next === 2 ? (
                    <InvestmentGold />
                  ) : hoverImg === 2 ? (
                    <InvestmentGold />
                  ) : (
                    <img loading="lazy" src={imgInvestment} width={'16px'} />
                  )}
                </Box>
                <Box className={styles.btnText}>
                  <Typography
                    variant="subtitle2"
                    className={`${styles.text} ${activeLink.next === 2 ? classes.ActiveNavText : ''}`}
                    component="div"
                  >
                    INVESTMENTS
                  </Typography>
                </Box>
              </NavLink>
            </Box>

            <Box marginBottom={2} onClick={(e) => navClickHandler(3)}>
              <NavLink
                onClick={() => {
                  setHoverImg(null);
                }}
                to="/farm"
                onMouseOver={() => setHoverImg(3)}
                onMouseOut={() => setHoverImg(null)}
                className={({ isActive }) =>
                  isActive
                    ? `${styles.activeRouteCollapse} ${classes.hoverNav} `
                    : `${styles.inActiveRouteCollapse} ${classes.hoverNav}`
                }
              >
                <Box className={styles.btnIcon}>
                  {theme === 'dark' ? (
                    <img loading="lazy" src={imgFarm} width={'16px'} />
                  ) : activeLink.next === 3 ? (
                    <FarmGold />
                  ) : hoverImg === 3 ? (
                    <FarmGold />
                  ) : (
                    <img loading="lazy" src={imgFarm} width={'16px'} />
                  )}
                </Box>
                <Box className={styles.btnText}>
                  <Typography
                    variant="subtitle2"
                    className={`${styles.text} ${activeLink.next === 3 ? classes.ActiveNavText : ''}`}
                    component="div"
                  >
                    FARM
                  </Typography>
                </Box>
              </NavLink>
            </Box>

            <Box marginBottom={2} onClick={(e) => navClickHandler(4)}>
              <NavLink
                onClick={() => {
                  setHoverImg(null);
                }}
                to="/faq"
                onMouseOver={() => setHoverImg(4)}
                onMouseOut={() => setHoverImg(null)}
                className={({ isActive }) =>
                  isActive
                    ? `${styles.activeRouteCollapse} ${classes.hoverNav} `
                    : `${styles.inActiveRouteCollapse} ${classes.hoverNav}`
                }
              >
                <Box className={styles.btnIcon}>
                  {theme === 'dark' ? (
                    <img loading="lazy" src={imgFaq} width={'16px'} />
                  ) : activeLink.next === 4 ? (
                    // <img loading="lazy" src={imgFaqGold} width={'16px'} />
                    <FaqGold />
                  ) : hoverImg === 4 ? (
                    <FaqGold />
                  ) : (
                    <img loading="lazy" src={imgFaq} width={'16px'} />
                  )}
                </Box>
                <Box className={styles.btnText}>
                  <Typography
                    variant="subtitle2"
                    className={`${styles.text} ${activeLink.next === 4 ? classes.ActiveNavText : ''}`}
                    component="div"
                  >
                    FAQ
                  </Typography>
                </Box>
              </NavLink>
            </Box>

            {theme === 'dark' ? (
              ''
            ) : (
              <Box sx={{ left: !toggleSidebar ? '-2%' : '32%' }} className={styles.godmode_text}>
                <Typography variant="subtitle2" component="div">
                  GODMODE
                </Typography>
              </Box>
            )}
          </Box>

          <Box sx={{ marginLeft: !toggleSidebar ? '-300px' : '0' }} className={styles.socialIcons}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <a
                href="https://discord.com/invite/thornodes"
                target="_blank"
                onMouseOver={() => setToggleImg(0)}
                onMouseOut={() => setToggleImg(null)}
              >
                <Button variant="text" size="small" sx={{ minWidth: '40px' }}>
                  <img src={toggleImg === 0 ? imgDiscordHover : imgDiscord} width={'20px'} />
                </Button>
              </a>
              <a
                href="https://twitter.com/_ThorFinancial"
                target="_blank"
                onMouseOver={() => setToggleImg(1)}
                onMouseOut={() => setToggleImg(null)}
              >
                <Button variant="text" size="small" sx={{ minWidth: '40px' }}>
                  <img src={toggleImg === 1 ? imgTwitterHover : imgTwitter} width={'20px'} />
                </Button>
              </a>
              <a
                href="https://docs.thor.financial/docs/guides/disclaimer"
                target="_blank"
                onMouseOver={() => setToggleImg(2)}
                onMouseOut={() => setToggleImg(null)}
              >
                <Button variant="text" size="small" sx={{ minWidth: '40px' }}>
                  <img src={toggleImg === 2 ? imgGitbookHover : imgStack} width={'20px'} />
                </Button>
              </a>
              <a
                href="https://thornodes.medium.com/"
                target="_blank"
                onMouseOver={() => setToggleImg(3)}
                onMouseOut={() => setToggleImg(null)}
              >
                <Button variant="text" size="small" sx={{ minWidth: '40px' }}>
                  <img src={toggleImg === 3 ? imgMediumHover : imgBubble} width={'20px'} />
                </Button>
              </a>
            </Box>
            <Box className={styles.line}></Box>
            <Box width={'100%'} display="flex" alignItems="center" justifyContent="space-between">
              <h2>
                UOT <br /> PARTNERS
              </h2>
              <Box display="flex" alignItems="center">
                <a href="https://app.powernode.io/" target="_blank">
                  <Button variant="text" size="small" sx={{ minWidth: '40px' }}>
                    <img src={bitmap} width={'20px'} />
                  </Button>
                </a>
                <a href="https://dapp.hive.investments/" target="_blank">
                  <Button variant="text" size="small" sx={{ minWidth: '40px' }}>
                    <img src={Object2} width={'20px'} />
                  </Button>
                </a>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LeftSideBar;
